if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      // 1. Pega o ID da mídia vindo do botão que clicou (zoom)
      let mediaId = this.openedBy.getAttribute("data-media-id");
      
      // Limpeza de segurança: Se o ID vier composto (ex: "template--123-456789"), pegamos só o final numérico
      if (mediaId && mediaId.includes('-')) {
        const parts = mediaId.split('-');
        // Assume que o ID numérico é a última parte
        mediaId = parts[parts.length - 1]; 
      }

      if (!mediaId) return;

      // 2. Procura dentro deste modal a miniatura correspondente ao ID.
      // O seletor procura por data-media-id OU data-target (usado no seu viewer)
      const targetThumb = this.querySelector(`li[data-media-id="${mediaId}"], li[data-target*="${mediaId}"]`);

      if (targetThumb) {
        // 3. A MÁGICA: Simula o clique na miniatura.
        // Isso aproveita toda a lógica que você já construiu no product-media-viewer
        // para carregar a imagem grande, vídeo ou modelo 3D correto.
        const clickableButton = targetThumb.querySelector('button');
        
        if (clickableButton) {
          clickableButton.click();
        } else {
          targetThumb.click();
        }

        // 4. Garante que a miniatura esteja visível no carrossel de thumbnails
        if (targetThumb.scrollIntoView) {
          targetThumb.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'center' });
        }
      } else {
        console.warn('ProductModal: Miniatura não encontrada para o ID:', mediaId);
      }
    }
  });
}